/**
 * 功能名称：审批流程抽象基类
 * 创 建 人：弋强
 * 日    期：2022/08/17 17:09:09
 */
import { BaseVue, ApproveData } from "@newview/base-web";

export abstract class BaseApprove extends BaseVue {
    /**
     * 初始化
     * @param approveData 
     * @param actReFlow 
     */
    abstract init(approveData: ApproveData, actReFlow: any): void;

    /**
     * 打开模态框
     */
    abstract openModal(): void;

    /**
     * 关闭模态框
     */
    abstract closeModal(): void;

    /**
     * 审批通过
     * @param isEnd 
     * @param approveData 
     */
    abstract pass(isEnd: boolean, approveData: ApproveData);

    /**
     * 审批回退
     * @param isStart 
     * @param approveData 
     */
    abstract return(isStart: boolean, approveData: ApproveData,data:any);

}